import React from 'react';
import { Typography } from '@attentive-platform/stem-ui';
import { GROUP_INPUT_DATA_FOR_BEAM_USER } from '../../Constants/Constants';

const CompanyInfoSection = ({ data = {}, readOnly = true, onFieldChange }) => (
  <div className='border border-gray-100 rounded-lg p-4 mb-4 bg-gray-50'>
    <div className='flex items-center gap-1 mb-3 pb-2 border-b border-gray-100'>
      <Typography variant='subtitle1-medium' color='var(--color-neutral-80)'>
        Company info
      </Typography>
    </div>

    {GROUP_INPUT_DATA_FOR_BEAM_USER.map(({ key, className, inputs }) => (
      <div key={key} className={className}>
        {inputs.map(({ label, valueKey, type, options, placeholder, ariaLabel }) => {
          const value = data[valueKey] ?? '';

          if (readOnly) {
            const displayValue = options ? (options[value] ?? value) : value;
            return (
              <React.Fragment key={valueKey}>
                <Typography className='input-group-text'>{label}</Typography>
                <input type='text' value={displayValue} disabled className='form-control' onChange={() => {}} />
              </React.Fragment>
            );
          }

          if (type === 'select') {
            return (
              <React.Fragment key={valueKey}>
                <Typography className='input-group-text'>{label}</Typography>
                <select
                  value={value}
                  onChange={e => onFieldChange?.(valueKey, e.target.value)}
                  className='form-select'
                  aria-label={ariaLabel}>
                  <option value=''>Select...</option>
                  {Object.entries(options).map(([optVal, optLabel]) => (
                    <option key={optVal} value={optVal}>
                      {optLabel}
                    </option>
                  ))}
                </select>
              </React.Fragment>
            );
          }

          return (
            <React.Fragment key={valueKey}>
              <Typography className='input-group-text'>{label}</Typography>
              <input
                type={type}
                value={value}
                onChange={e => onFieldChange?.(valueKey, e.target.value)}
                className='form-control'
                placeholder={placeholder}
                aria-label={ariaLabel}
              />
            </React.Fragment>
          );
        })}
      </div>
    ))}
  </div>
);

export default CompanyInfoSection;
